// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__-L4fW","title":"ClientInsurance_title__xfQ6a","itemText":"ClientInsurance_itemText__3lqid"};